@if (true) {
<div>
    <mce-project-header [project]="project()" class="cables-project-header"></mce-project-header>
</div>
}

<div>

    <div [style.display]="vm.showDatatable ? 'block': 'none'">

        <div class="mb-4">
            <mat-toolbar [attr.test-id]="'cables-toolbar'">
                <mat-toolbar-row class="mce-datatable-toolbar-row flex-col">

                    <div class="flex w-full items-center justify-between">

                        <div class="flex gap-2">


                            <mce-responsive-action-button [label]="'Delete'"
                                                          [icon]="'delete'"
                                                          [disabled]="vm.disableDelete"
                                                          (buttonClick)="onDeleteCables(selectedRows())">
                            </mce-responsive-action-button>


                            <mce-responsive-action-button [label]="'Copy'"
                                                          [icon]="'content_copy'"
                                                          [disabled]="vm.copySelectedDisabled"
                                                          (buttonClick)="onCopyCables(selectedRows())">
                            </mce-responsive-action-button>

                            <mce-responsive-action-button [label]="'Move'"
                                                          [icon]="'reorder'"
                                                          [disabled]="vm.moveSelectedDisabled"
                                                          (buttonClick)="onMoveCables(selectedRows())">
                            </mce-responsive-action-button>


                            <ng-container *ngTemplateOutlet="reportsMenu"></ng-container>
                        </div>

                        <div class="self-end">
                            <mce-responsive-action-button [label]="'Add Cable'"
                                                          [icon]="'add'"
                                                          (buttonClick)="addCable()"
                                                          [disabled]="vm.cableCreationDisabled">
                            </mce-responsive-action-button>
                        </div>

                    </div>

                </mat-toolbar-row>
            </mat-toolbar>
        </div>

        @if (vm.freePlanLimitReached || vm.freePlanLimitExceeded)
        {
        <div class="mb-4">
            <mce-info-message type="warning">
                Free Plan users can only have three cables. To create more cables, please <a routerLink="/account" class="underline">upgrade to Pro</a>.
                @if (vm.freePlanLimitExceeded) {
                <p class="mt-2">
                    Editing and moving cables are disabled until you delete cables so that only three remain. Upgrade to Pro to remove all Free Plan limits.
                </p>
                }
            </mce-info-message>
        </div>
        }


        <mce-data-table [displayedColumns]="vm.dataTable.displayedColumns"
                        [data]="vm.dataTable.data"
                        [headers]="vm.dataTable.headers"
                        [cellTemplates]="vm.dataTable.templates"
                        [showSelect]="vm.dataTable.showSelect"
                        (rowsSelected)="selectedRows.set($event)">

            <ng-template #rowActions let-row="row">
                <div style="width:108px;">
                    <button mat-icon-button (click)="onEditCable(row)" [disabled]="vm.freePlanLimitExceeded"
                            [attr.test-id]="'button-cable-edit'">
                        <mat-icon>edit</mat-icon>
                    </button>

                    <button mat-icon-button [matMenuTriggerFor]="moreActions">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #moreActions>

                        <button mat-menu-item (click)="onEditCable(row)" [disabled]="vm.freePlanLimitExceeded">
                            <mat-icon>edit</mat-icon>Edit Cable
                        </button>
                        <button mat-menu-item (click)="onCopyCable(row)" [disabled]="vm.cableCreationDisabled">
                            <mat-icon>content_copy</mat-icon>Copy Cable
                        </button>
                        <button mat-menu-item (click)="onMoveCable(row)" [disabled]="vm.freePlanLimitExceeded">
                            <mat-icon>reorder</mat-icon>Move Cable
                        </button>
                        <button mat-menu-item (click)="onDeleteCable(row)">
                            <mat-icon>delete</mat-icon>Delete
                        </button>

                        <button mat-menu-item
                                matTooltip="Issues with the cable, please open a ticket quoting reference {{row.uid}}. Click to copy reference to clipboard."
                                [cdkCopyToClipboard]="row.uid">
                            <mat-icon>chat_info</mat-icon>Reference
                        </button>

                    </mat-menu>
                </div>
            </ng-template>

        </mce-data-table>

    </div>

    @if (vm.showLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

</div>

@if (vm.showSpinner) {
<div class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
}

@if (vm.showEditForm) {
<cable-edit [cable]="vm.editCable"
            [comments]="vm.editComments"
            [showDebugPanel]="vm.showDebugPanel"
            (cancelClick)="onCancel()"
            (saveClick)="onEditSave($event)">
</cable-edit>
}


<ng-template #reportsMenu>

    <button mat-raised-button color="accent" [matMenuTriggerFor]="reportsMenu" [disabled]="vm.disableReportsButton" (menuOpened)="refreshRecentReports()" aria-label="Reports">
        <mat-icon>file_download</mat-icon><span class="hidden sm:inline">Reports</span>
    </button>

    <mat-menu #reportsMenu="matMenu">
        @if (recentReports().length) {
        <button mat-menu-item [matMenuTriggerFor]="menuRecentReports">
            <mat-icon>history</mat-icon>
            Recent Reports
        </button>
        <mat-divider></mat-divider>
        }
        <button mat-menu-item (click)="onDoReports(report.CablesList)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Cable List
        </button>
        <button mat-menu-item [matMenuTriggerFor]="menuCableSchedule">
            <mat-icon>menu</mat-icon>
            Cable Schedule
        </button>
        <button mat-menu-item [matMenuTriggerFor]="menuCalculation">
            <mat-icon>menu</mat-icon>
            Calculation
        </button>
        <button mat-menu-item [matMenuTriggerFor]="menuProject">
            <mat-icon>menu</mat-icon>
            Project
        </button>

        <button mat-menu-item [matMenuTriggerFor]="menuOther">
            <mat-icon>menu</mat-icon>
            Other
        </button>

        <mat-divider></mat-divider>

        <button mat-menu-item (click)="onDoExport()" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Export
        </button>

    </mat-menu>

    <mat-menu #menuRecentReports="matMenu" aria-label="Recent Reports">
        <p class="px-4 py-2 text-sm">Available for up to 24 hours@if (!isSharedBillingMember()) {; opening uses no credits}</p>
        @for (recentReport of recentReports(); track recentReport.url) {
        <button mat-menu-item (click)="openRecentReport(recentReport)">
            <mat-icon>open_in_new</mat-icon>
            <span class="flex flex-col py-1">
                <span>{{ recentReport.name }}</span>
                <span class="text-sm">{{ recentReport.generatedAt | date:'d MMM, HH:mm:ss' }}</span>
            </span>
        </button>
        }
    </mat-menu>

    <mat-menu #menuCableSchedule="matMenu">
        <button mat-menu-item (click)="onDoReports(report.CableScheduleV1)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Cable Schedule V1
        </button>
        <button mat-menu-item (click)="onDoReports(report.CableScheduleV2)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Cable Schedule V2
        </button>
        <button mat-menu-item (click)="onDoReports(report.CableComments)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Cable Comments
        </button>
    </mat-menu>

    <mat-menu #menuCalculation="matMenu">
        <button mat-menu-item (click)="onDoReports(report.CableSizing)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Cable Sizing
        </button>
        <button mat-menu-item (click)="onDoReports(report.PowerLoss)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Power Loss
        </button>
    </mat-menu>

    <mat-menu #menuProject="matMenu">
        <button mat-menu-item (click)="onDoReports(report.ProjectSummary)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Project Summary
        </button>
        <button mat-menu-item (click)="onDoReports(report.ProjectCableSizing)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Project Cable Sizing
        </button>
    </mat-menu>

    <mat-menu #menuOther="matMenu">

        <button mat-menu-item (click)="onDoReports(report.LoadList)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Load List
        </button>
        <button mat-menu-item (click)="onDoReports(report.MTOCables)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            MTO - Cables
        </button>
        <button mat-menu-item (click)="onDoReports(report.VoltageDropMatrix)" [disabled]="!vm.dataTable.data.length">
            <mat-icon>file_download</mat-icon>
            Voltage Drop Matrix
        </button>
    </mat-menu>

</ng-template>
